
import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";

/**✅ Employee Levels Thunk */
export const employeeLevelsThunk = createAsyncThunk(
    "employees/employeeLevelsThunk",
    async (_, { rejectWithValue, getState }) => {
        const state = getState();
        // 👈 Skip API if data already in state
        if (state.employees?.employeeLevels?.length > 0) {
            return state.employees.employeeLevels;
        }

        try {
            const response = await api.post(API_ROUTES.EMP_LEVELS);
            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch branch departments");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ Employee Modules Thunk */
export const employeeModulesThunk = createAsyncThunk(
    "employees/employeeModulesThunk",
    async (_, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (state.employees?.employeeModules?.length > 0) {
            return state.employees.employeeModules;
        }

        try {
            const response = await api.post(API_ROUTES.EMP_MODULES, {
                "client_id": user?.client_id
            });
            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch branch departments");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ add Employee Thunk **/
export const addEmployeeThunk = createAsyncThunk(
    "employees/addEmployeeThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            "employee_id": user?.user_id,
            "client_id": user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.ADD_EMPLOYEE, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Employee Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Employee Adding failed"
            );
        }
    }
);

/**✅ get Employee Thunk **/
export const getEmployeeThunk = createAsyncThunk(
    "employees/getEmployeeThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        if (payload.type !== "getEmpData") {
            if (state.employees?.getEmployees?.length > 0) {
                return state.employees.getEmployees;
            }
        }

        try {
            const response = await api.post(API_ROUTES.EMPLOYEES, {
                "client_id": user?.client_id,
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Employees");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ update Employee Thunk **/
export const updateEmployeeThunk = createAsyncThunk(
    "employees/updateEmployeeThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            "employee_id": user?.user_id,
            "client_id": user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.UPDATE_EMPLOYEE, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Employee Update failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Employee Update failed"
            );
        }
    }
);
